import { cn } from "@theprelude/core";

export const BookIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 17 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.5 11.9999H4.5C4.32319 11.9999 4.15362 12.0702 4.0286 12.1952C3.90357 12.3202 3.83333 12.4898 3.83333 12.6666C3.83333 12.8434 3.90357 13.013 4.0286 13.138C4.15362 13.263 4.32319 13.3333 4.5 13.3333H14.5V14.6666H4.5C3.96957 14.6666 3.46086 14.4559 3.08579 14.0808C2.71071 13.7057 2.5 13.197 2.5 12.6666V2.66659C2.5 2.31296 2.64048 1.97382 2.89052 1.72378C3.14057 1.47373 3.47971 1.33325 3.83333 1.33325H14.5V11.9999ZM3.83333 10.6999C3.94133 10.6779 4.05267 10.6666 4.16667 10.6666H13.1667V2.66659H3.83333V10.6999ZM11.1667 5.99992H5.83333V4.66659H11.1667V5.99992Z" />
  </svg>
);
